import { Money } from "types/landlord/reports";
import {
  VerificationSchema,
  Template
} from "types/landlord/verificationTemplate";
import { Asset } from "shared/app/IdentityVerificationReport/types";
import { Application, CriteriaRentType } from "shared/types";

export interface TemplateResponse {
  verification_template: Template;
}

export interface VerificationSchemasResponse {
  verification_schemas: VerificationSchema[];
}

export interface GetTemplatesResponse {
  object: string;
  current_page: number;
  extra: null | unknown;
  has_more: boolean;
  items: Template[];
  page_count: number;
  total_count: number;
}

export enum UnlistUnitTiming {
  NEVER = "never",
  ON_FIRST_APPLICATION = "on_first_application",
  ON_APPROVE = "on_approve"
}

export enum AdverseActionLetterType {
  Generic = "generic",
  Washington = "washington"
}

export interface AdverseActionLetterSignature extends Asset {
  value: string;
}

export interface TemplateSettings {
  automatically_unlist_unit_timing: UnlistUnitTiming;
  notify_applicants: boolean;
  display_rent_amount: boolean;
  display_available_date: boolean;
  has_pet_rent: boolean;
  has_voucher: boolean;
  pet_rent_value?: Money;
  has_move_in_date_limit: boolean;
  max_move_in_days?: number;
  min_move_in_days?: number;
  auto_approve_enabled?: boolean;
  auto_approve_delay?: number;
  auto_approve_delay_enabled?: boolean;
  auto_approve_delay_type?: string;
  auto_approve_delay_value?: number;
  adverse_action_letter_type: AdverseActionLetterType;
  adverse_action_letter_signature?: {
    svg?: AdverseActionLetterSignature | string;
    png?: AdverseActionLetterSignature | string;
  };
  adverse_action_letter_address?: {
    street_address?: string;
    apartment_address?: string;
    city?: string;
    state?: string;
    postal_code?: string;
  };
  criteria_rent_type?: CriteriaRentType;
  /** Question the primary applicant answers before starting; each route decides the template. Null when off. */
  routing_question?: string | null;
  routing_enabled?: boolean;
  /** Answer options in display order. Detail payloads only. */
  routes?: TemplateRoute[];
  /** Identifier of the template this one is a variant of; variants are edited only inside their parent. */
  parent_template_identifier?: string | null;
  /** This template's variants. Detail payloads only. */
  variants?: TemplateVariant[];
}

export interface TemplateRoute {
  key?: string;
  label: string;
  /** Null keeps the applicant on this template. */
  target_template_identifier: string | null;
  position?: number;
}

export interface TemplateVariant {
  id: string;
  name: string;
}

export interface Additional {
  page: number;
  propertyId: number;
}

export interface ChangeTemplateResponse {
  application: Application;
  warnings?: {
    type: string;
    message: string;
    verifications: string[];
  }[];
}
